import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UnusedTile } from '../../../state-management/models/report-dashboard.model';
import { DashboardContext } from '../../../../../admin/contexts/dashboard.context';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ziro-dashboard-unused-devices-tile',
  templateUrl: './dashboard-unused-devices-tile.component.html',
  standalone: false,
})
export class DashboardUnusedDevicesTileComponent implements OnInit {
  private _dashboardContext = inject(DashboardContext);

  unusedTileData$: Observable<UnusedTile> = this._dashboardContext.state$.pipe(map((state) => state.unusedTile));

  ngOnInit(): void {
    this._dashboardContext.loadUnusedTile();
  }
}
